module.exports = __webpack_public_path__ + "img/fill-exp-font.42e4a74f.png";